import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/hydiene-system/hydiene.css";
import HelmetWrapper from "../../HelmetWrapper";
import PageStarter from "../../components/hygiene-system/hygiene-common/PageStarter";
import { selectUser } from "../../components/auth/auth.selector";
import TaskFrequency from "../../components/hygiene-system/task-frequency/TaskFrequency";
import { fetchHygieneTaskFrequencyData } from "../../redux/hygiene-reducers/hygieneSlice";
import TaskFrequencyForm from "../../components/hygiene-system/task-frequency/TaskFrequencyForm";

const HygineTaskFrequency = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModalvalues = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getHygieneTasksFrequenecy(filters) {
    dispatch(
      fetchHygieneTaskFrequencyData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getHygieneTasksFrequenecy(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Hygiene task frequenecy">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModalvalues}
          contentLabel="Hygiene Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName === "add" || modValues.cardName === "edit"
                ? "mod-width-50p"
                : ""
            }`}
          >
            {modValues.cardName === "add" || modValues.cardName === "edit" ? (
              <TaskFrequencyForm
                userInfoData={userInfoData}
                callFunction={() => getHygieneTasksFrequenecy(filters)}
                closeModal={onCloseModalvalues}
                isEdit={modValues.cardName === "edit"}
                rowData={modValues.rowData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <PageStarter
              pageName={"Hygiene task frequenecy"}
              btnLabel={"+ Add new"}
              searchPlaceHolder={"frequenecy"}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              onClickAdd={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }));
              }}
              isReload={() => getHygieneTasksFrequenecy(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TaskFrequency
              userInfoData={userInfoData}
              setModValues={setModValues}
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => getHygieneTasksFrequenecy(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HygineTaskFrequency;
